<template>
  <div class="content">
    <img
      class="banner"
      src="http://shanghai-siggraph.oss-cn-hangzhou.aliyuncs.com/admin/images/20241212/网站图片_画板 1 副本 2(5).jpg"
      alt=""
    />
  </div>
  <div class="about">
    <div class="thehome">
      <span @click="topath('/')">{{ $t("header.home") }}</span> &nbsp;/
    </div>

    <div class="us_content">
      <div class="us1">
        <div class="us1_left">
          <img
            src="http://shanghai-siggraph.oss-cn-hangzhou.aliyuncs.com/admin/images/20231110/icon_arrow.svg"
            alt=""
          />
        </div>
        <div class="us1_right">
          <div>{{ $t("header.questions") }}</div>
          <div>{{ $t("header.method_below") }}</div>
        </div>
      </div>
      <div class="us2">
        {{ $t("header.Shanghai") }} ACM SIGGRAPH {{ $t("header.Association") }}
      </div>
      <div class="us3">
        <div>{{ $t("header.contact") }}</div>
      </div>
      <div class="us4">
        <div class="us4_title">{{ $t("header.telephone") }}:</div>
        <div class="us4_botom">
          <div class="us4_left">
            <img
              src="http://shanghai-siggraph.oss-cn-hangzhou.aliyuncs.com/admin/images/20231110/contact_icon_arrow.svg"
              alt=""
            />
          </div>
          <div>15618301990</div>
        </div>
      </div>
      <div class="us4">
        <div class="us4_title">{{ $t("header.email") }}:</div>
        <div class="us4_botom">
          <div class="us4_left">
            <img
              src="http://shanghai-siggraph.oss-cn-hangzhou.aliyuncs.com/admin/images/20231110/contact_icon_arrow.svg"
              alt=""
            />
          </div>
          <div>secretariat@siggraph.cn</div>
        </div>
      </div>
    </div>
    <!-- <div class="title">
      <div class="one animate__animated animate__backInLeft">
        {{ $t("header.contact") }}
      </div>
    </div> -->
    <!-- <div class="contactus animate__animated animate__backInUp">
      <div>
        {{
          (locale == "zh" && state.contatuslist.intro) ||
          state.contatuslist.en_intro
        }}
      </div>
      <div v-for="(item, index) in state.contatuslist.details" :key="index">
        {{ (locale == "zh" && item.title) || item.en_title }}:
        {{ item.content }}
      </div>
    </div> -->
  </div>
</template>
<script setup>
// http://shanghai-siggraph.oss-cn-hangzhou.aliyuncs.com/admin/images/20231110/icon_arrow.svg
// http://shanghai-siggraph.oss-cn-hangzhou.aliyuncs.com/admin/images/20231110/contact_icon_arrow.svg
import { contactus } from "@/api/type";
import { useRouter } from "vue-router";
import { reactive } from "vue";
const router = useRouter();
import { useI18n } from "vue-i18n";
const { locale } = useI18n();
const state = reactive({
  contatuslist: [],
});
contactus({}).then((res) => {
  state.contatuslist = res.data[0];
  console.log(state.contatuslist, 989);
});
const topath = (e) => {
  router.push(e);
};
</script>
<style lang="scss" scoped>
@import "@/sass/index.scss";
.content {
  z-index: 0;
  max-width: 1468px;
  margin: 0 auto;
  height: 500px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  .banner {
    height: 100%;
    position: absolute;
    // width: 100%;
    top: 0;
    bottom: 0;
    // background-image: url("https://bunseninstitute.oss-cn-hangzhou.aliyuncs.com/files/images/ralf-leineweber-sRMzAdjWK_E-unsplash_%E7%9C%8B%E5%9B%BE%E7%8E%8B(1).jpg");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
  }
}
.about {
  max-width: 1176px;
  margin: 0 auto;
  text-align: left;
  .thehome {
    margin: 28px 0 80px 0;
    @include fontstyle(#333, 14px, 400, auto);
  }
  .us_content {
    max-width: 940px;
    background: #4155d9;
    // opacity: .1;
    margin: 0 auto;
    padding: 60px 130px;
    box-sizing: border-box;
    margin-bottom: 60px;
    text-align: left;
    color: #ed765c;
    .us1 {
      display: flex;
      align-items: center;
      .us1_left {
        background: #ffffff;
        width: 66px;
        height: 66px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        margin-right: 28px;
      }
      .us1_right {
        line-height: 23px;
      }
    }
    .us2 {
      font-size: 34px;
      line-height: 40px;
      font-weight: 800;
      margin-top: 30px;
    }
    .us3 {
      font-size: 52px;
      line-height: 61px;
      font-weight: 800;
      margin-top: 5px;
      margin-bottom: 74px;
    }
    .us4 {
      margin-top: 20px;
      .us4_botom {
        display: flex;
        align-items: center;
        padding: 24px 0px;
        border-bottom: 1px solid #e6755a;
        .us4_left {
          margin-right: 16px;
        }
        :nth-child(2) {
          font-size: 36px;
          font-weight: 800;
          line-height: 42px;
        }
      }
    }

    // :nth-child(1) {
    //   @include fontstyle(#333, 14px, 400, auto);
    //   margin-bottom: 48px;
    // }
    // :nth-child(2) {
    //   @include fontstyle(#333, 28px, 800, auto);
    //   margin-bottom: 28px;
    // }
    // :nth-child(3) {
    //   @include fontstyle(#333, 28px, 800, auto);
    // }
  }
  .title {
    display: flex;
    flex-direction: column;
    align-items: center;

    .one {
      text-align: center;
      display: inline-block;
      @include fontstyle(#333, 40px, 800, auto);
      line-height: 47px;
      margin-bottom: 48px;
      border-bottom: 8px solid #f4775e;
      padding-bottom: 3px;
    }
  }
}
@media screen and (max-width: 1200px) {
  .about {
    padding: 30px;
    .contactus {
      :nth-child(2) {
        @include fontstyle(#333, 18px, 800, auto);
      }
      :nth-child(3) {
        @include fontstyle(#333, 18px, 800, auto);
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .us_content {
    padding: 20px 20px !important;
    .us1_left {
      height: 44px !important;
      width: 44px !important;
      margin-right: 12px !important;
      img {
        width: 22px !important;
      }
    }
    .us1_right {
      :nth-child(n) {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 220px;
      }
    }
    .us2 {
      font-size: 20px !important;
    }
    .us3 {
      font-size: 26px !important;
    }
    .us4 {
      :nth-child(2) {
        font-size: 20px !important;
      }
    }
  }

  .content {
    height: auto;
    .banner {
      width: 100%;
      height: auto;
    }
  }
}
</style>
